import { makeParams } from "@/utils/helper"
import { API } from "."
import {
  CreateStadiumPayload,
  CreateStadiumResponse,
  ReadStadiumByActivityResponse,
  ReadStadiumByTeamAndPeriodParams,
  ReadStadiumByTeamAndPeriodResponse,
  ReadStadiumInfoResponse,
  ReadStadiumListParams,
  ReadStadiumListResponse,
  ReadStadiumListByBoundaryParams,
  ReadStadiumListByBoundaryResponse,
} from "@/types/stadium"

/* 경기장 목록 조회 */
export async function readStadiumList(params: ReadStadiumListParams) {
  return await API.get<ReadStadiumListResponse>("/stadiums", { params })
}

export async function readStadiumListByMapBoundary({
  minLat,
  maxLat,
  minLng,
  maxLng,
}: ReadStadiumListByBoundaryParams) {
  const params = makeParams({ minLat, maxLat, minLng, maxLng })

  return await API.get<ReadStadiumListByBoundaryResponse>("/stadiums/within", { params })
}

/* 경기장 정보 조회 */
export async function readStadiumInfo(idfStadium: number) {
  return await API.get<ReadStadiumInfoResponse>(`/stadiums/${idfStadium}`)
}

/* 액티비티 경기장 정보 조회 */
export async function readStadiumByActivity(idfActivity: number) {
  return await API.get<ReadStadiumByActivityResponse>(
    `/stadiums/activity?idfActivity=${idfActivity}`,
  )
}

/* 경기장 추가 */
export async function createStadium(payload: CreateStadiumPayload) {
  return await API.post<CreateStadiumResponse>("/stadiums", payload)
}

/* 액티비티 경기장 장보 조회 */
export async function readStadiumByTeamAndPeriod(params: ReadStadiumByTeamAndPeriodParams) {
  const { idfTeam, dateStart, dateFinish } = params

  return await API.get<ReadStadiumByTeamAndPeriodResponse>(
    `/stadiums/team?idfTeam=${idfTeam}&start=${dateStart}&end=${dateFinish}`,
  )
}
